import { FC } from 'react';
import { Button, Grid, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { useStyles } from './styles';

interface StreamingButtonProps {
    icon: string;
    altText: string;
    title: string;
    onClick: () => void;
}

const StreamingButton: FC<StreamingButtonProps> = ({ icon, altText, title, onClick }) => {
    const classes = useStyles();

    return (
        <Button onClick={onClick} className={classes.buttonContainer}>
            <Grid
                container
                xs={12}
                justify="center"
                alignContent="center"
                alignItems="center"
                direction="column"
                className={clsx(classes.container)}
            >
                <img className={clsx(classes.instructionIcon)} src={icon} alt={altText} />
                <Grid item className={clsx(classes.textContainer)}>
                    <Typography className={clsx(classes.text, classes.instructionTitle)}>{title}</Typography>
                </Grid>
            </Grid>
        </Button>
    );
};

export default StreamingButton;
